import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import callAPI from '../../../helpers/callAPI'
import Loading from '../../../templates/UI/Loading/Loading'
import Dollars from '../../../templates/Dollars/Dollars'
import { SystemMessageContext } from '../../../context/SystemMessageContext'
import queryString from 'query-string'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import Campaign from '../../../templates/Campaign/Campaign'
import DownloadCSV from '../../../templates/DownloadCSV/DownloadCSV'

const CommissionsHistoryDetailsModal = ({ isOpen, onClose, adminId, date, mode = 'history' }) => {
    const { showSystemMessage } = React.useContext(SystemMessageContext)
    const [dataLoaded, setDataLoaded] = useState(false)
    const [details, setDetails] = useState(null)    

    const rows = Array.isArray(details?.report) ? details.report : []

    const formatCommissionMonthYear = (value) => {
        if (!value) {
            return ''
        }

        const parsedDate = new Date(`${value}T00:00:00Z`)

        if (Number.isNaN(parsedDate.getTime())) {
            return String(value)
        }

        return parsedDate
            .toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric',
                timeZone: 'UTC',
            })
    }

    const displayMonthYear = formatCommissionMonthYear(date)

    useEffect(() => {
        let isMounted = true

        const fetchDetails = async () => {
            if (!isOpen || !adminId) {
                return
            }

            setDataLoaded(false)
            setDetails(null)

            const detailsQuery = queryString.stringify({
                adminId,
                date,
                mode
            })
            const result = await callAPI(`reports/commissions/details?${detailsQuery}`, 'GET')

            if (!isMounted) {
                return
            }

            if (result?.success === true) {
                setDetails(result)
                setDataLoaded(true)
                return
            }

            if (result?.success === false) {
                showSystemMessage('error', result?.errors?.message || 'There was an error fetching the admin commission details. Please try again.')

                setDetails(null)
                setDataLoaded(true)
                return
            }

            showSystemMessage('error', result?.errors?.message || 'Could not load the admin commission details.')
            setDetails(null)
            setDataLoaded(true)
        }

        fetchDetails()

        return () => {
            isMounted = false
        }
    }, [isOpen, adminId, date, showSystemMessage])

    useEffect(() => {
        if (!isOpen) {
            setDetails(null)
            setDataLoaded(false)
            }
        }, [isOpen])

    return (
        <Modal show={isOpen} onHide={onClose} size="xl">
            <Modal.Header closeButton>
                <div className="d-flex align-items-center justify-content-between w-100 mr-3">
                    <Modal.Title className="mb-0">Commission Details: {(dataLoaded && details) ? `${details.admin.name} - ${displayMonthYear}` : ''}</Modal.Title>
                    {dataLoaded && rows.length > 0 && (
                        <DownloadCSV
                            filename={`Commission Details - ${details.admin.name} - ${displayMonthYear}`}
                            headerLabels={['Affiliate ID', 'Name', 'Campaign', 'Margin Type', 'Margin', 'Notes']}
                            data={rows}
                            dataLabels={['affiliate_id', 'name', 'offer_name', 'margin_type', 'margin', 'notes']}
                        />
                    )}
                </div>
            </Modal.Header>
            <Modal.Body className="p-0">
                {!adminId ? (
                    <div className="p-2">No admin selected.</div>
                ) : !dataLoaded ? (
                    <Loading />
                ) : rows.length === 0 ? (
                    <div className="p-2">No details available for this admin.</div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-striped table-card table-hover mb-0 text-small">
                            <thead>
                                <tr>
                                    <th>Affiliate ID</th>
                                    <th>Name</th>
                                    <th>Campaign</th>
                                    <th>Margin Type</th>
                                    <th className="text-right">Margin</th>
                                    <th>Notes</th>
                                    {/* <th>Email</th>
                                    <th>Contact</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => {
                                    return (
                                        <tr key={`${row.affiliate_id}-${row.e_mail}-${index}`}>
                                            <td>{row.affiliate_id}</td>
                                            <td><Affiliate aid={row.affiliate_id} status={row.aff_status} name={row.name} priority={row.aff_priority} /></td>                                            
                                            <td><Campaign oid={row.offer_id} name={row.offer_name} status={row.status_value} affiliateStatus={row.affiliate_offer_status}/></td>
                                            <td>{row.margin_type || '-'}</td>
                                            <td className="text-right"><Dollars value={row.margin} /></td>
                                            <td>{row.notes || '-'}</td>
                                            {/* <td>{row.e_mail || '-'}</td>
                                            <td>{row.contact || '-'}</td> */}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    )
}

export default CommissionsHistoryDetailsModal
